import React from 'react';
import { MenuItem } from '@nextiva/next-ui-components';
import { useGetDataFileWithErrors } from './hooks/useGetDataFileWithErrors';

export const DownloadErrorButton = ({ jobId }) => {
  const { isLoading, refetch } = useGetDataFileWithErrors(jobId);

  const downloadErrorFile = async () => {
    await refetch();
  };

  return (
    <MenuItem
      disabled={isLoading}
      onClick={downloadErrorFile}
      data-testid="PlatformAdminUI-HistoryLog-ErrorFile"
    >
      Download error file
    </MenuItem>
  );
};
